<template>
  <div class="content">
    <div style="width: 1096px; height: 100vh">
      <iframe
        title="Word Document Preview"
        :src="`https://fp.easyloon.com/service_${$i18n.locale}_V1.0.3.html`"
        width="100%"
        height="100%"
        frameBorder="0"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceAgreement'
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
